"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWindow = exports.getNavigator = exports.getLocalStorage = exports.getDocument = void 0;
var _fp = require("lodash/fp");
var serverStub = {
  location: {},
  onerror: _fp.noop
};
var localStorageStub = {
  getItem: _fp.noop,
  removeItem: _fp.noop,
  setItem: _fp.noop
};
var getDocument = function getDocument() {
  if (typeof window !== 'undefined') {
    return document;
  }
  return serverStub;
};
exports.getDocument = getDocument;
var getNavigator = function getNavigator() {
  if (typeof window !== 'undefined') {
    return navigator;
  }
  return serverStub;
};
exports.getNavigator = getNavigator;
var getWindow = function getWindow() {
  if (typeof window !== 'undefined') {
    return window;
  }
  return serverStub;
};
exports.getWindow = getWindow;
var getLocalStorage = function getLocalStorage() {
  if (typeof localStorage !== 'undefined') {
    return localStorage;
  }
  return localStorageStub;
};
exports.getLocalStorage = getLocalStorage;